import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import TableViewOutlinedIcon from "@mui/icons-material/TableViewOutlined";

const ExportButton = ({ label, tooltip, loading, disabled, icon, onClick }) => (
  <Tooltip title={tooltip} arrow>
    <Box component="span" sx={{ display: "block", width: { xs: "100%", sm: "auto" } }}>
      <Button
        variant="outlined"
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : icon}
        onClick={onClick}
        disabled={disabled || loading}
        sx={{ width: { xs: "100%", sm: "auto" } }}
      >
        {loading ? "Exportando..." : label}
      </Button>
    </Box>
  </Tooltip>
);

const MealProjectExports = ({
  projectSelected,
  controlLoading,
  closureLoading,
  onExportControl,
  onExportClosure,
}) => (
  <Box>
    <Typography variant="subtitle2" fontWeight={900} mb={1}>
      Exportaciones
    </Typography>
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "stretch", sm: "center" }}>
      <ExportButton
        label="Exportar incidencias"
        tooltip="Descarga el control de incidencias MEAL del proyecto y filtros seleccionados."
        loading={controlLoading}
        disabled={!projectSelected}
        icon={<FileDownloadOutlinedIcon />}
        onClick={onExportControl}
      />
      <ExportButton
        label="Exportar base revisada"
        tooltip="Descarga los datos actuales del proyecto junto con el estado de revisión MEAL."
        loading={closureLoading}
        disabled={!projectSelected}
        icon={<TableViewOutlinedIcon />}
        onClick={onExportClosure}
      />
    </Stack>
    <Typography variant="caption" color="text.secondary" display="block" mt={1}>
      La base revisada usa los datos actuales del proyecto y puede descargarse mientras la revisión MEAL está en proceso.
    </Typography>
  </Box>
);

export default MealProjectExports;
